const CHANNEL_WEB = "lawfully_web";
const CAMPAIGN_MOBILE = "mobile";
const CAMPAIGN_DESKTOP = "desktop";

export type Adgroup =
  | "Case Tracker"
  | "Mock Interview"
  | "Community"
  | "Nav"
  | "USMEx"
  | "Hub"
  | "Resources"
  | "DS-TrendGraph"
  | "Footer";

export function getAirbridgeTrackerLink(
  isMobile: boolean,
  adgroup?: Adgroup,
  creative?: string,
  fallbackDesktop?: string,
) {
  const append = `campaign=${isMobile ? CAMPAIGN_MOBILE : CAMPAIGN_DESKTOP}${
    adgroup ? `&ad_group=${encodeURIComponent(adgroup)}` : ""
  }${
    adgroup && creative ? `&ad_creative=${encodeURIComponent(creative)}` : ""
  }${
    fallbackDesktop
      ? `&fallback_desktop=${encodeURIComponent(fallbackDesktop)}`
      : ""
  }`;

  return `https://abr.ge/@lawfully/${CHANNEL_WEB}?${append}`;
}

export type Store = "ios" | "android";

/**
 * Where a desktop click on a store link lands. The `/us/` storefront and the
 * `lawfully-case-tracker` slug are the canonical spellings -- Apple 301s the
 * others, including the older `my-uscis-case-status-tracker` one still in the
 * footer (see `pages/mobile/appstore.tsx`).
 */
const STORE_URL: Record<Store, string> = {
  ios: "https://apps.apple.com/us/app/lawfully-case-tracker/id1435063223",
  android:
    "https://play.google.com/store/apps/details?id=com.lawfully.lawfully_ai_tracker&hl=en_US&gl=US&pli=1",
};

/**
 * A tracker link pinned to one store rather than routed by the clicker's OS,
 * for links that name their platform ("iPhone", "Android").
 *
 * `fallback_desktop` is what does the pinning, and it is the only fallback
 * worth setting: Airbridge consults it exactly when the click comes from a
 * desktop browser, which is where every caller of this lives. A click from a
 * phone would be routed by that phone's OS instead, so an "iPhone" link tapped
 * on Android cannot be made to open the App Store -- and none of the callers
 * render on a phone anyway.
 *
 * `store` doubles as the ad_creative, so the two platforms stay apart in
 * Airbridge without the caller having to name them twice.
 */
export function getAirbridgeStoreLink(
  store: Store,
  campaign: string,
  adgroup: string,
) {
  const append = [
    `campaign=${encodeURIComponent(campaign)}`,
    `ad_group=${encodeURIComponent(adgroup)}`,
    `ad_creative=${encodeURIComponent(store)}`,
    `fallback_desktop=${encodeURIComponent(STORE_URL[store])}`,
  ].join("&");

  return `https://abr.ge/@lawfully/${CHANNEL_WEB}?${append}`;
}
